import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c961ab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { class: "high-light" }
const _hoisted_6 = { style: { color: '#F43838' } }
const _hoisted_7 = { class: "ranking" }
const _hoisted_8 = { class: "mark" }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Tabs, Tab, Overlay, Loading, Empty } from "vant";
import { formatPercentage } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'OfflineArea',
  setup(__props) {

const route = useRoute();

const productOrderPayCountAsc = ref(false); // 产品-下单成功量升序
// const orderPayRateAsc = ref(false); // 下单成功率升序

const visible = ref(false);
const pageData = ref<any>({});
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/offline/list-area-visit-store",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      officeName: route.params.area,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data?.[0] || {};
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

// 区域排行
const areaList = ref<any>([]);
const getProductsData = async () => {
  const res = await request({
    url: "/api/wx/offline/list-sales-visit-store",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      officeName: route.params.area,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    areaList.value = res.data;
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

watch(productOrderPayCountAsc, () => {
  getProductsData();
});

// const handleChange = (name: number) => {

// };

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  document.title = `${route?.params.area}区域销售拜访日报`;
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              title: `当日拜访店铺总量：`,
              size: "large",
              class: "bold"
            }, {
              value: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(pageData.value.value), 1),
                  _createTextVNode(" (环比："),
                  _createElementVNode("span", {
                    style: _normalizeStyle({
                    color:
                      pageData.value.extendAttributes?.percentage >= 0
                        ? 'red'
                        : 'green',
                  })
                  }, _toDisplayString(`${
                      pageData.value.extendAttributes?.percentage >= 0 ? "+" : ""
                    }${_unref(formatPercentage)(pageData.value.extendAttributes?.percentage)}`), 5),
                  _createTextVNode(") ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(route)?.params.area) + "销售跑店排行榜", 1),
        _createVNode(_unref(Cell), {
          title: "销售姓名",
          value: "跑店数量",
          style: { background: '#E5F6F4', fontWeight: 500 }
        }),
        (!areaList.value.length)
          ? (_openBlock(), _createBlock(_unref(Empty), {
              key: 0,
              description: "暂无数据",
              "image-size": "100"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(Cell), {
              key: index,
              title: item.name,
              style: _normalizeStyle({ fontSize: '0.3rem' })
            }, {
              value: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.value) + "(环比：", 1),
                _createElementVNode("span", {
                  style: _normalizeStyle({
                  color:
                    item.extendAttributes?.percentage >= 0 ? 'red' : 'green',
                })
                }, _toDisplayString(`${
                    item.extendAttributes?.percentage >= 0 ? "+" : ""
                  }${_unref(formatPercentage)(item.extendAttributes?.percentage)}`), 5),
                _createTextVNode(") ")
              ]),
              _: 2
            }, 1032, ["title", "style"]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})